import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useQuery } from '@apollo/react-hooks';
import { change } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import validate from './validate';
import{useRentalItemValidation} from './ValidationTitle'
import { useStyles } from './styles';

import { GET_STATUSES, GET_TYPES } from 'graphql/queries/rental-items'

import {
  DEFAULT_LANGUAGE,
  AVAILABLE_LANGUAGES,
} from 'pages/create-rental-items/constants';

import {
  Input,
  MultipleSelectField,
  FormActionButtons,
  DndUploadImage,
  DropDown,
  CircularLoader
} from 'components/index';

const initialValues = {
  productCode: ''
};

const RentalItemsGeneralCreate = ({
  handleSubmit,
  isUpdate,
  setSubmitButton,
  formValues = {},
  itemType,
  status,
  ...otherProps
}) => {
  const {
    languages,
    selectedLanguage,
    addLanguage,
    deleteLanguage,
    selectLanguage
  } = otherProps;
  const [t] = useTranslation();
 
  const dispatch = useDispatch();

  const {
    validationErrors,
    updateField,
    validateOnSubmit,
    loading : titleLoading
  } = useRentalItemValidation();

  const onSubmitHandler = (e) => {
    e.preventDefault();
    const isValid = validateOnSubmit(formValues);
    if (!isValid) return; 

    handleSubmit(e); 
  };

const { data: statusData, loading: isLoading } = useQuery(GET_STATUSES);
const { data: typeData, loading: isLoadingType } = useQuery(GET_TYPES);

const [options, setOptions] =  React.useState([]);
const [typeOptions, setTypeOptions] = React.useState([]);

  React.useEffect(() => {
    if (statusData?.allRentalItemStatuses) {
      const statusOne = statusData.allRentalItemStatuses.find(
        status => status.id === 1
      );

      if (statusOne) {
        setOptions([{
          id: statusOne.id,
          status: statusOne.status,
        }]);
        dispatch(change('generalForm', 'status', statusOne.id));
      }
    }
  }, [statusData, dispatch]); 

React.useEffect(() => {
  if (typeData?.allRentalItemTypes) {
    setTypeOptions(
      typeData.allRentalItemTypes.map((type) => ({
        id: type.id,
        itemType: type.type,
      }))
    );
  }
}, [typeData]);

  const classes = useStyles();
  const availableLanguages = [...AVAILABLE_LANGUAGES].filter(
    x => !languages.includes(x)
  );


  return (
    <>
     <CircularLoader
     loaderClassName={classes.loaderClassName}
     className={classes.loaderWrapper}
    />
    
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('General')}
      </Typography>
      <MultipleSelectField
        availableItems={availableLanguages}
        notAvailableToDeleteItems={[DEFAULT_LANGUAGE]}
        list={languages}
        selectedItem={selectedLanguage}
        addItem={addLanguage}
        deleteItem={deleteLanguage}
        selectItem={selectLanguage}
      />
      <form onSubmit={onSubmitHandler}>
        <div className={classes.row}>
          <div className={classes.column}>
            <Field
              className={classes.inputIndent}
              name="coverPhoto"
              label="Cover photo *"
              component={DndUploadImage}
            />
          </div>
          <div className={classes.column}>
            <Field
              name="title"
              placeholder="Title"
              className={classes.inputIndent}
              label="Title *"
              component={Input}
              onChangeCustom={value => updateField('title', value)}
              error={Boolean(validationErrors.title)}
            />
             <Field
                isOnlyNumber={true}
                name="availableUnits"
                placeholder=" No.Of Units"
                label="Available Units / Available Seats *"
                className={classes.inputIndent}
                component={Input}
              />
             {isUpdate && (
              <Field
                name="productCode"
                disabled
                placeholder="Product code"
                className={classes.inputIndent}
                label="Product code"
                component={Input}
              />
           )}
          </div>
        </div>
         <div className={classes.row}>
          <div className={classNames(classes.column)}>
              <Field
                name="status"
                label="Status *"
                placeholder="Choose status"
                component={DropDown}
                list={options}
                field="status"
                 className={classNames(classes.inputIndent,classes.dropDown)}
              />
          </div>

          <div className={classNames(classes.column)}>
              <Field
                name="itemType"
                label="Item Type *"
                placeholder="Select item type"
                component={DropDown}
                list={typeOptions}
                field="itemType"
                className={classNames(classes.inputIndent,classes.dropDown)}
              />
          </div>
        </div>

         <div className={classes.row}>
              <div className={classes.column}>
                    <Field
                      name="minDays"
                      isOnlyNumber={true}
                      maxLength={9}
                      placeholder="Number of Days"
                      className={classes.inputIndent}
                      label="Min. number of days *"
                      component={Input}
                    />
                  </div>
                  <div className={classes.column}>
                    <Field
                      name="maxDays"
                      isOnlyNumber={true}
                      maxLength={9}
                      placeholder="Number of Days"
                      className={classes.inputIndent}
                      label="Max. number of days *"
                      component={Input}
                    />
                  </div>
          </div>

        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
    </>
  );
};

export default reduxForm({
  form: 'generalForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  useRentalItemValidation,
  initialValues
})(RentalItemsGeneralCreate);
